import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useQueries from '../../../database/useQueries'
import { useSelector } from 'react-redux'
import { format, parseISO } from 'date-fns'
import { getFieldOptions, CommponentOptions } from '../plagins/data/commponentOptions'
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { v4 as uuidv4 } from 'uuid';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves'
import { createFetchDataServer, getTableData } from '../../../database/fetchData'
import { GlobalContext } from '../../../App'

const NAME_ENTITY = ' מחירון'

function PaymentCreate() {

  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data)
  const columns = useSelector((state) => state.columnsFormPayments.data)
  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
  const { 
    contextCemeteries, contextBlocks, contextPlots, contextRows } = useContext(DataContext);

const [loading, setLoading] = useState(true); // מצב טעינה

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, getEntitiesByAttr, addOrUpdateDataPayment } = useQueries();

  // ערכי הראוטר
  const location = useLocation()
  const navigate = useNavigate()
  const { value, grave } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, permission, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת מחירון`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([])
  const [blocks, setBlocks] = useState([])
  const [plots, setPlots] = useState([])
  const [rows, setRows] = useState([])
  
  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns
    return localColumns.map(field => {
      return ({
        ...field,
        // כאן ניתן להוסיף חוקים לנעילת שדה או להיפך
        disabled: field.disabled && (grave !== undefined),
        // כאן ניתן להוסיף חוקים לחובת שדה או להיפך
        required: (field.required || false),
        // כאן ניתן להוסיף חוקים להסתרת שדה או להיפך
        show: field?.show || false,
      })
    });
  };
  
  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {!loading && handleAllDataLoaded()}, [loading]);
  
  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns())
    let initialFormValues = myColumns().filter(field => field?.name).reduce((acc, field) => {
      let fieldValue = '';
      if (field.input === 'date') {
        fieldValue = format(new Date(), 'yyyy-MM-dd')
      }
      return {
        ...acc,
        [field.name]: fieldValue,
      };
    }, {});
          fieldAuto(initialFormValues)

      setFormValues(initialFormValues)
  }
  
  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (newFormValues) => {
    setCemeteries(
      [
        CommponentOptions({ value: '', label: '' }),
        ...contextCemeteries.map(cemetery => CommponentOptions({ value: cemetery?.unicId, label: cemetery?.cemeteryNameHe }))
      ]
    )
    setBlocks(
      [
        CommponentOptions({ value: '', label: '' }),
        ...contextBlocks.map(block => {
          const cemetery = contextCemeteries.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: block?.unicId, label: block?.blockNameHe, dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          })
        })
      ]
    )
    setPlots(
      [
        CommponentOptions({ value: '', label: '' }),
        ...contextPlots.map(plot => {
          const block = contextBlocks.find(block => block?.unicId === plot?.blockId)
          const cemetery = contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: plot?.unicId, label: plot?.plotNameHe,
            dataUnderRigth: { title: 'גושים: ', value: block?.blockNameHe },
            dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe },
          })
        })
      ]
    )
    setRows(
      [CommponentOptions({ value: '', label: '' })]
    )
    return newFormValues
  };

  const fieldChangeCemeteryId = (event, newFormValues) => {
    let blocks = contextBlocks
    let plots = contextPlots
    let res = {}
    if (event.target.value !== -1) {
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;
      blocks = getEntitiesByAttr(contextBlocks, 'cemeteryId', event.target.value)
      plots = contextPlots.filter(plot =>
        blocks.some(block => block?.unicId === plot.blockId)
      )
    }
    else {
      res = { plotId: -1, blockId: -1, lineId: -1 }
      setRows([CommponentOptions({ value: '', label: '' })])
    }
    setBlocks(
      [
        CommponentOptions({ value: '', label: '' }),
        ...blocks.map(block => {
          const cemetery = contextCemeteries.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: block?.unicId, label: block?.blockNameHe, dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          })
        })
      ]
    )
    setPlots(
      [
        CommponentOptions({ value: '', label: '' }),
        ...plots.map(plot => {
          const block = contextBlocks.find(block => block?.unicId === plot?.blockId)
          const cemetery = contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
          return CommponentOptions({
            value: plot?.unicId, label: plot?.plotNameHe,
            dataUnderRigth: { title: 'גוש: ', value: block?.blockNameHe },
            dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe },
          })
        })
      ]
    )
    return res
  }
  const fieldChangeBlockId = (event, newFormValues) => {
    let res = {}
    if (event.target.value !== -1) {
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;

      const block = getEntityByAttr(contextBlocks, 'unicId', event.target.value)
      const cemetery = getEntityByAttr(contextCemeteries, 'unicId', block?.cemeteryId)

      const plots = getEntitiesByAttr(contextPlots, 'blockId', event.target.value)

      setPlots(
        [
          CommponentOptions({ value: '', label: '' }),
          ...plots.map(plot => {
            const block = contextBlocks.find(block => block?.unicId === plot?.blockId)
            const cemetery = contextCemeteries?.find(cemetery => cemetery?.unicId === block?.cemeteryId)
            return CommponentOptions({
              value: plot?.unicId, label: plot?.plotNameHe,
              dataUnderRigth: { title: 'גוש: ', value: block?.blockNameHe },
              dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe },
            })
          })
        ]
      )

      res = { cemeteryId: cemetery?.unicId }
    }
    else {
      res = { plotId: -1, lineId: -1 }
      setRows([CommponentOptions({ value: '', label: '' })])
    }
    return res
  }
  const fieldChangePlotId = (event, newFormValues) => {
    let res = {}
    if (event.target.value !== -1) {
      delete newFormValues?.lineId;

      const plot = getEntityByAttr(contextPlots, 'unicId', event.target.value)
      const block = getEntityByAttr(contextBlocks, 'unicId', plot?.blockId)
      const cemetery = getEntityByAttr(contextCemeteries, 'unicId', block?.cemeteryId)

      const rows = getEntitiesByAttr(contextRows, 'plotId', event.target.value)

      setRows(
        [
          CommponentOptions({ value: '', label: '' }),
          ...rows.map(row => {
            return CommponentOptions({
              value: row?.unicId, label: row?.lineNameHe,
              dataUnderRigth: { title: 'חלקה: ', value: plot?.plotNameHe },
              dataUnderLeft: { title: 'גוש: ', value: block?.blockNameHe },
            })
          })
        ]
      )
      res = { blockId: block?.unicId, cemeteryId: cemetery?.unicId }
    }
    else {
      res = { lineId: -1 }
      setRows([CommponentOptions({ value: '', label: '' })])
    }
    return res
  }
  const handleChange = (event) => {
    let newFormValues = formValues
    let value = event.target.value
    if (event.target.name === 'cemeteryId') {
      const res = fieldChangeCemeteryId(event, newFormValues)
      newFormValues = { ...newFormValues, ...res }
    }
    if (event?.target?.name === 'blockId') {
      const res = fieldChangeBlockId(event, newFormValues)
      newFormValues = { ...newFormValues, ...res }
    }
    if (event?.target?.name === 'plotId') {
      const res = fieldChangePlotId(event, newFormValues)
      newFormValues = { ...newFormValues, ...res }
    }

    if (event?.target?.name === 'test') {
      setFormValues({ ...newFormValues, [event.target.name]: format(parseISO(event.target.value), 'yyyy-MM-dd') });
    }
    else {
      setFormValues({ ...newFormValues, [event.target.name]: value });
    }
  }
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach(field => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some(item => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);
      let newFormValues = formValues

      const unicId = uuidv4()

      // הוספת unicId לערך השדות לפני השליחה
      const updatedFormValues = {
        ...newFormValues,
        unicId: unicId
      };

      let res = await addOrUpdateDataPayment(updatedFormValues, unicId);
      if (res === 200) {
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
         if (dataCemeteries && dataBlocks && dataPlots && dataRows) {
          setLoading(false);
        }
      }
      fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows'], token);
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />

  return (
    <>
      <FormTemplate
      title={`הוספת ${NAME_ENTITY}`}
      btn={`שמור`}
        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        // lockUpdate={value !== undefined}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots,
          lineId: rows,
          plotType: getFieldOptions('plotType', optionsFields, true),
          graveType: getFieldOptions('graveType', optionsFields, true),
          resident: getFieldOptions('resident', optionsFields, true),
          priceDefinition: getFieldOptions('priceDefinition', optionsFields, true),
          buyerStatus: getFieldOptions('buyerStatus', optionsFields, true),
        }}
      />
      <p><span style={{ fontFamily: "'Courier New', Courier, monospace" }}>יצירת מחירון</span></p>
    </>
  );
}

export default PaymentCreate;
